const clientDataApi = {
  en: {
    client_data_api: {
      title: "Client Data API",
      header: "Coding / Client Data API",
      search_placeholder: "Search projects or clients",
      no_access: "You do not have permission to view the Client Data API page.",
      permissions_failed: "Could not load Client Data API permissions. Check your connection and try again.",
      retry: "Retry",
      no_projects: "No projects found",
      columns: {
        project: "Project",
        uid: "Project UID",
        hierarchy: "Parent / child",
        enabled: "API enabled",
        keys: "Keys"
      },
      hierarchy: {
        parent: "Main project",
        child: "Child of {parent}"
      },
      manage_keys: "Keys",
      copy_uid: "Copy project UID",
      uid_copied: "Project UID copied",
      switch: {
        pending: "Syncing with Insight…",
        enabled: "Client Data API enabled for {project}",
        disabled: "Client Data API disabled for {project}",
        sync_failed: "Insight sync failed, so the change was reverted. Try again.",
        sync_failed_unreverted: "Insight sync failed and the change could not be reverted. Bodhi and Insight may be out of sync — refresh and check again.",
        failed: "Could not update the Client Data API switch."
      },
      panel: {
        uid_hint: "Clients put this UID in the request URL. The switch and keys apply to this exact project only; a parent and its children are switched separately.",
        status_enabled: "API enabled",
        status_disabled: "API disabled",
        disabled_notice: "Turn the API on for this project before generating keys. Existing keys are denied while the API is off."
      },
      generate: {
        title: "Generate key",
        label: "Label",
        label_placeholder: "e.g. Power BI production",
        expires_at: "Expires on",
        expires_hint: "Keys expire after at most 12 months.",
        submit: "Generate key",
        submitting: "Generating…",
        success: "Key generated",
        switch_off: "The API is off for this project, so a key cannot be generated.",
        failed: "Could not generate the key."
      },
      reveal: {
        title: "New key",
        notice: "Copy this key now. You will not see it again.",
        copy: "Copy key",
        copied: "Key copied to clipboard",
        copy_failed: "Could not copy automatically. Select the key and copy it manually.",
        done: "I have copied the key"
      },
      keys: {
        title: "Keys",
        empty: "No keys yet",
        load_failed: "Could not load keys.",
        prefix: "Prefix",
        label: "Label",
        created_at: "Created",
        expires_at: "Expires",
        last_used_at: "Last used",
        status: "Status",
        never: "Never",
        revoke: "Revoke",
        statuses: {
          active: "Active",
          expired: "Expired",
          revoked: "Revoked"
        }
      },
      revoke: {
        title: "Revoke key",
        message: "Revoke key {prefix}? Clients using it will be denied immediately. This cannot be undone.",
        confirm: "Revoke",
        success: "Key revoked",
        failed: "Could not revoke the key."
      }
    }
  }
};

module.exports.clientDataApi = clientDataApi;
